import { useEffect, useState } from 'react'
import { Button, Stack, TableCell, TableRow } from '@mui/material'
import { Item } from './snippets'
import { Box, useTheme } from '@mui/system'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from './font/Roboto-bold'
import { callAddFontRobotoMedium } from './font/Roboto-Medium-normal'
import moment from 'moment'
import { focusElemnt, getLocalData, navigation3 } from './helper'
import { useAtom } from 'jotai'
import VirtualizedTable from './virtualisedTable'
import { divideInNIntegers, withPercentWidths, withPxWidths } from './mathHelper'
import { exportToExcel } from './hook'
import { CargoRoleRightsAtom } from './jotaiState/commonStateAtoms'
import { xlCol } from './constants'
import useToken from '../helpers/useTokens'
import { makeTable } from '../content/Reports/analysisReport/pdfAutotable'
import { lrDetailPdfFooter } from '../content/AcountingReport/common/AcountingConstants'
import { fixColSpan } from '../content/Reports/common/reportUtils'
import AppsIcon from '@mui/icons-material/Apps'
import ManageColumns from './ManageColumnsUI'
import { modalAtom } from './jotaiState/globalStateAtoms'
import SearchFilter from './SearchFilter'
const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')

export const TableComponent = (props) => {
  const theme = useTheme()
  const [modal, setModal] = useAtom(modalAtom)
  const { tableHeaderColor } = theme
  const { reportName = '', hideControls = false } = props
  const { startID = '', endID = '' } = props
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  const { AllowExportExcel = 1, AllowPrintandPdf = 1 } = { ...roleRightsData }
  const { loginData } = useToken()
  const [searchResult, setSearchResult] = useState(true)
  const { criteriaHeaders = [] } = props
  const { criteriaData = [] } = props
  const { mainHeader = [] } = props
  const { tableData = [] } = props
  const { excelTableData = [] } = props
  const nonViewHeaders = mainHeader.filter((col) => col.ViewOnly !== true).map((a) => ({ ...a, field: a.field?.replace(/_view$/, '') }))
  const { isShowManageColumn = false, manageColumnID } = props
  const { hideHeader = false, isShowPdfPrint = true, colSpanMarker = '' } = props
  const [manageColumn, setManageColumn] = useState([])
  const [columns, setColumns] = useState([])
  const [updatedTableData, setUpdatedTableData] = useState([])
  const [matches, setMatches] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const tables = [
    { id: 'mainTable', data: tableData, columnDefs: columns, totalColDef: [] },
  ];
  const visibleColumns = columns.length ? columns : mainHeader
  const setColumn = async () => {
    const savedColumns = await getLocalData(manageColumnID)
    let defaultColumns = []
    if (Array.isArray(savedColumns) && savedColumns.length > 0) {
      defaultColumns = savedColumns
    } else {
      defaultColumns = mainHeader
    }
    setManageColumn(defaultColumns)
    if (isShowManageColumn) {
      setColumns(defaultColumns.filter((col) => col.isSelected === true))
    } else {
      setColumns(mainHeader)
    }
  }
  useEffect(() => {
    const init = async () => {
      await setColumn()
    }
    init()
  }, [manageColumnID, mainHeader])
  useEffect(() => {
    if (!colSpanMarker || !columns.length) {
      setUpdatedTableData(tableData)
      return
    }

    const markerIndex = columns.findIndex(
      (col) => col.field === colSpanMarker
    )

    if (markerIndex === -1) {
      setUpdatedTableData(tableData)
      return
    }

    const updated = tableData.map((row) => {
      if (row?.dataType !== 'total' || !row?.colSpan) return row

      const firstField = Object.keys(row.colSpan)[0]
      const span = markerIndex + 1

      return {
        ...row,
        colSpan: {
          ...row.colSpan,
          [firstField]: span,
        },
      }
    })

    setUpdatedTableData(updated)
  }, [tableData, columns, colSpanMarker])

  const [criteriaHeaderExcel, criteriaDataExcel] = fixColSpan(criteriaHeaders, criteriaData, visibleColumns)
  const excelHeaders = visibleColumns.flatMap((col) => {
    if (typeof col.field === 'string' && col.field.includes('^^')) {
      const [field1, field2] = col.field.split('^^')
      const [header1, header2] = (col.exportHead || '').split('\n')
      return [
        { field: field1, header: header1, align: col.align },
        { field: field2, header: header2, align: col.align },
      ]
    }
    return { ...col, field: col.field, header: col.exportHead?.replace(/\n/g, ' '), align: col.align }
  })
  const span1 = divideInNIntegers(excelHeaders.length, 2)

  const header1 = [
    [
      { header: `Report For: ${reportName}`, field: '', span: span1[0], mainHeader: true },
      { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
    ],
  ]
  const excelHeaderList = [header1, criteriaHeaderExcel, excelHeaders]
  const excelDataList = [[], criteriaDataExcel]
  excelDataList.push(excelTableData.length ? excelTableData : updatedTableData)

  const printClick = (isSave) => {
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = criteriaHeaders.map((col) => {
      return { header: col.header, dataKey: col.field, xlCol: col.xlCol || xlCol }
    })
    const pdfFontSize = 1
    const orientation = visibleColumns.length > 14 ? 'l' : 'p'
    const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
    const pdfColumns = withPxWidths(visibleColumns, format[0] - 60).map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width || 0 }
    })
    const doc = new jsPDF({ orientation: orientation, format: format, unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `${reportName}.pdf`,
      subject: `${reportName}`,
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    const customFunction = (data, doc) => {
      doc.setTextColor(40)
      doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
      doc.setFontSize(26).setFont('Roboto', 'bold')
      doc.setTextColor(16, 79, 162)
      doc.text(`Cargo System | ${reportName}`, 30 + 60, 80)
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(22).setFont('Roboto', 'bold')
      doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
    }
    const customFunction2 = (data, doc) => {
      lrDetailPdfFooter(data, loginData, totalPagesExp)
    }
    makeTable(doc, autoTable, HeaderColumns, criteriaData, pdfFontSize, reportName, loginData, 'everyPage', customFunction, 120, false)
    makeTable(doc, autoTable, pdfColumns, updatedTableData, pdfFontSize, reportName, loginData, hideHeader ? 'never' : 'everyPage', customFunction2)

    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`${reportName} ${currentDateTime}.pdf`)
    } else {
    }
    setTimeout(() => {
      const pdfUrl = doc.output('bloburl')
      document.getElementById('anaLRDetailsOutput').data = pdfUrl
      // document.getElementById('anaLRDetailsOutput').data = doc.output('datauristring', `${reportName}.pdf`)
      focusElemnt('backBtn')
    }, 2000)
  }
  const headerContent = () => {
    let viewHeader = withPercentWidths(columns)
    return (
      <>
        <TableRow>
          {viewHeader.map((item) => {
            return (
              <TableCell
                style={{
                  backgroundColor: tableHeaderColor?.isHeadingColor,
                  color: '#444',
                  fontSize: '12px',
                  lineHeight: '16px',
                  letterSpacing: '0.24px',
                  fontWeight: '600',
                  whiteSpace: 'pre-line',
                  padding: '6px 8px',
                  width: item.width,
                  textAlign: item.align || 'left',
                }}
                colSpan={1}
              >
                {item?.header}
              </TableCell>
            )
          })}
        </TableRow>
      </>
    )
  }
  const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs, matches, currentMatch }) => {
    if (!row?.dataType) return null
    const getStyles = (field, align) => {
      const common = {
        minHeight: '36px',
        fontSize: '12px',
        color: '#444',
        padding: '6px 8px',
      }
      if (row.dataType === 'header') {
        return {
          ...common,
          fontWeight: '700',
          backgroundColor: tableHeaderColor?.isHeadingColor,
          textAlign: align,
        }
      }
      if (row.dataType === 'entry') {
        return {
          ...common,
          fontWeight: '500',
          textAlign: align || 'left',
          height: '36px',
          whiteSpace: 'pre-line',
        }
      }
      if (row.dataType === 'subHeader') {
        return {
          ...common,
          fontWeight: '600',
          backgroundColor: tableHeaderColor?.isSubHeadingColor,
          textAlign: row.align?.[field] || 'left',
          position: 'sticky',
        }
      }
      if (row.dataType === 'total') {
        return {
          ...common,
          fontWeight: '600',
          backgroundColor: tableHeaderColor?.isTotalColor,
          textAlign: row.align?.[field] || 'right',
        }
      }
    }

    return (
      <>
        {(() => {
          let skip = 0

          return columnDefs.map((item, i) => {
            if (skip > 0) {
              skip--
              return null
            }
            const colSpan = row.colSpan?.[item.field] || 1
            skip = colSpan - 1
            const key = `${index}-${item.field}`
            const isMatched = matches?.has(key)
            const isActive =
              currentMatch &&
              currentMatch.rowIndex === index &&
              currentMatch.field === item.field
            return (
              <TableCell
                data-field={item.field}   // 👈 ADD THIS LINE
                className="reportTD"
                key={item.field + i + index}
                colSpan={colSpan}
                style={getStyles(item.field, item.align)}
              >
                <span style={{ backgroundColor: isActive ? 'orange' : isMatched ? 'yellow' : 'transparent' }} > {row[item.field]} </span>
              </TableCell>
              // <TableCell className="reportTD" key={item.field + i + index} colSpan={colSpan} style={getStyles(item.field, item.align)}>
              //   {row[item.field]}
              // </TableCell>
            )
          })
        })()}
      </>
    )
  }
  const bodyContent = (index, obj, extra) => {
    return <DisPatchBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={columns} matches={extra.matchSet} currentMatch={extra.currentMatch} />
  }
  const onSaveColumns = (items) => {
    setManageColumn(items)
    setColumns(items.filter((col) => col.isSelected === true))
    localStorage.setItem(manageColumnID, JSON.stringify(items))
  }
  return (
    <>
      <SearchFilter
        tables={tables}
        matches={matches}
        setMatches={setMatches}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
      />
      <Stack style={{ margin: '10px' }}>
        <Item className="userReport" style={{ padding: 0, display: hideControls ? 'none' : 'flex' }}>
          <Item className="userReport-heading" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
            Report For: {reportName}
            {isShowManageColumn && (
              <Box
                style={{ height: '32px', display: 'flex', padding: '8px 12px', justifycontent: 'center', alignitems: 'center', gap: '6px' }}
                id="dispatchReportManageColumn"
                tabIndex={0}
                onClick={() => setModal('ShowManageColumn')}
              >
                <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                  <AppsIcon />
                </span>
                <span tabIndex={0} style={{ fontWeight: 'bold' }}>
                  MANAGE COLUMNS
                </span>
              </Box>
            )}
          </Item>
          <Item className="userReport-buttons" style={{ paddingRight: 0 }}>
            {searchResult ? (
              <>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    disabled={!AllowExportExcel}
                    onClick={() =>
                      exportToExcel({
                        fileName: `${reportName} ${currentDateTime}.xlsx`,
                        sheetName: reportName,
                        headersList: excelHeaderList,
                        dataList: excelDataList,
                      })
                    }
                  >
                    Export to Excel
                  </Button>
                </Box>
                {
                  isShowPdfPrint && <>
                    <Box>
                      <Button
                        variant="outlined"
                        className="userWisereporttembtn"
                        onClick={() => {
                          setSearchResult(false)
                          printClick(true)
                        }}
                        disabled={!AllowPrintandPdf}
                        onKeyDown={(e) =>
                          navigation3(e, 'analPrintBtn', !AllowPrintandPdf ? startID : 'analsExpToExlbtn', () => {
                            setSearchResult(false)
                            printClick(true)
                          })
                        }
                        id="anaxportAsPdfBtn"
                      >
                        Export to Pdf
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        variant="outlined"
                        className="userWisereporttembtn"
                        onClick={() => {
                          setSearchResult(false)
                          printClick(false)
                        }}
                        disabled={!AllowPrintandPdf}
                        id="analPrintBtn"
                        onKeyDown={(e) =>
                          navigation3(e, endID, 'anaxportAsPdfBtn', () => {
                            setSearchResult(false)
                            printClick(false)
                          })
                        }
                      >
                        Print
                      </Button>
                    </Box>
                  </>
                }
              </>
            ) : (
              <>
                <Box>
                  <Button
                    id="backBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, startID, endID, () => {
                        setSearchResult(true)
                        focusElemnt(endID)
                      })
                    }
                  >
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      <Stack style={{ margin: '0px 10px' }}>
        {searchResult ? (
          <VirtualizedTable
            id="mainTable"
            tableData={updatedTableData}
            headerContent={hideHeader ? false : headerContent}
            rowContent={bodyContent}
            tableStyle={{ tableLayout: 'auto', width: '100%' }}
            autoResize={true}
            matches={matches}
            currentIndex={currentIndex}
          />
        ) : (
          <object
            id="anaLRDetailsOutput"
            type="application/pdf"
            width={'100%'}
            height="440"
            title={`MTLPL -Cargo System -${reportName}`}
            aria-label={`MTLPL -Cargo System -${reportName}`}
          ></object>
        )}
      </Stack>
      {modal === 'ShowManageColumn' && <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={setModal} />}
    </>
  )
}
